import {CheckoutModel} from '../models/checkout/Checkout.model';

export const isPartiallyPaid = (checkout: CheckoutModel) => !!checkout.payLater?.total.amount;

export const getTotal = (checkout: CheckoutModel) =>
  !isPartiallyPaid(checkout)
    ? checkout.payNowTotalAfterGiftCard.formattedAmount
    : checkout.totalAfterGiftCard!.formattedAmount;
